import { useAtomValue } from 'jotai';
import { Fragment } from 'react';

import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { hstack, square, stack } from '@flipster/styled-system/patterns';

import { useProductConfig } from '../../product-config';

export const HowItWorksTab = () => {
  const { detailsAtom } = useProductConfig();
  const details = useAtomValue(detailsAtom);
  const redemptionHours = details?.redemptionProcessingTimeHours ?? '48';
  const steps = [
    {
      title: <FormattedMessage id='Earn.r260224.How_it_works_step_1_title' />,
      desc: <FormattedMessage id='Earn.r260224.How_it_works_step_1_description' />,
    },
    {
      title: <FormattedMessage id='Earn.r260224.How_it_works_step_2_title' />,
      desc: <FormattedMessage id='Earn.r260224.How_it_works_step_2_description' />,
    },
    {
      title: <FormattedMessage id='Earn.r260224.How_it_works_step_3_title' />,
      desc: <FormattedMessage id='Earn.r260224.How_it_works_step_3_description' />,
    },
    {
      title: <FormattedMessage id='Earn.r260224.How_it_works_step_4_title' />,
      desc: <FormattedMessage id='Earn.r260224.How_it_works_step_4_description' values={{ hour: redemptionHours }} />,
    },
  ];

  return (
    <div className={stack({ gap: 0 })}>
      {steps.map((step, idx) => (
        <Fragment key={idx}>
          <div className={hstack({ gap: 16 })}>
            <div
              className={square({
                size: 24,
                borderColor: 'border.default.level-2',
                borderWidth: '1px',
                borderStyle: 'solid',
                rounded: 4,
                bg: 'background.accent.secondary.tint',
                textStyle: 'Text/S/Regular',
              })}
            >
              {idx + 1}
            </div>
            <div className={stack({ gap: 4 })}>
              <p className={css({ textStyle: 'Text/L/Strong', color: 'content.default.level-5' })}>{step.title}</p>
              <p className={css({ textStyle: 'Text/S/Regular', color: 'content.default.level-2' })}>{step.desc}</p>
            </div>
          </div>
          {idx < steps.length - 1 && <div className={css({ bg: 'border.default.level-1', w: 1, h: 20, mx: 12 })} />}
        </Fragment>
      ))}
    </div>
  );
};
